import { render } from "./MTokenExclusiveWarning.vue?vue&type=template&id=4c680a99&scoped=true&ts=true"
import script from "./MTokenExclusiveWarning.vue?vue&type=script&lang=ts"
export * from "./MTokenExclusiveWarning.vue?vue&type=script&lang=ts"

import "./MTokenExclusiveWarning.vue?vue&type=style&index=0&id=4c680a99&lang=scss"
import "./MTokenExclusiveWarning.vue?vue&type=style&index=1&id=4c680a99&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c680a99"]])

export default __exports__